import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.nutrientPrices',
    modules: [
        R,
    ],
})
@Service('NutrientPricesStore')
export default class NutrientStore extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.one('nutrients-price');
    }

    refresh () {
        var self = this;
        this.loading = true;

        return this.endpoint.get(this.params)
            .then(function(data){
                self.list = data;
                return self;
            })
            .finally(function(){
                self.loading = false;
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/nutrient.price.js